import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/workSummary`;

export const ROUTE: RouteDefinition = `${baseRoute}/workSummary`;

export const URL = (): RouteDefinition => `${baseRoute}/workSummary`;
